import { onAuthStateChanged } from 'firebase/auth'
import React, { createContext, useEffect, useReducer } from 'react'
import { useNavigate } from 'react-router-dom'
import { auth } from '../../Firebase/firebase'
import reducerAuth, { initialStateAuth } from './authReducer'

const AuthContext = createContext()

const AuthProvider = ({children}) => {
    const [store, dispatch] = useReducer(reducerAuth, initialStateAuth)
    const navigate = useNavigate()

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (!user) {
                dispatch({type: "setAuth", payload: null});
                /*// Solo redirigir al login si no estamos ya en login
                if (window.location.pathname !== '/login') {
                    navigate("/login")
                }*/
            } else {
                dispatch({type: "setAuth", payload: user});
            }
        })
        return () => {
            unsubscribe() 
        }
    }, [navigate])

    return (
        <AuthContext.Provider value={[store, dispatch]}>
            {children}
        </AuthContext.Provider>
    )
}

export { AuthContext }
export default AuthProvider